import { api } from './api';
import type { RoadmapItem, FunnelData } from '../types';

function buildQuery(params?: Record<string, string | undefined>): string {
  if (!params) return '';
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== '');
  if (!entries.length) return '';
  return '?' + entries.map(([k, v]) => `${k}=${encodeURIComponent(v!)}`).join('&');
}

export const roadmapApi = {
  list: (params?: { phase?: string; status?: string; market?: string; category?: string }) =>
    api.get<RoadmapItem[]>(`/roadmap${buildQuery(params)}`),
  create: (data: Partial<RoadmapItem>) => api.post<RoadmapItem>('/roadmap', data),
  update: (id: number, data: Partial<RoadmapItem>) => api.patch<RoadmapItem>(`/roadmap/${id}`, data),
  remove: (id: number) => api.delete<{ ok: boolean }>(`/roadmap/${id}`),
  seed: () => api.post<{ inserted: number; total: number }>('/roadmap/seed'),
};

export const funnelApi = {
  get: (market?: string) =>
    api.get<FunnelData>(`/stats/funnel${market ? `?market=${market}` : ''}`),
};
